export default __webpack_public_path__ + "static/media/EDITAR.296e9b9f.svg";